import React from 'react';
import { CheckCircle, XCircle, HelpCircle } from 'lucide-react';

interface LeadQualifiedBadgeProps {
  isQualified: boolean | null;
  size?: 'sm' | 'md' | 'lg';
}

const LeadQualifiedBadge: React.FC<LeadQualifiedBadgeProps> = ({
  isQualified,
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-xs',
    lg: 'px-3 py-1.5 text-sm'
  };

  const iconSizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-3.5 h-3.5',
    lg: 'w-4 h-4'
  };

  if (isQualified === true) {
    return (
      <span
        className={`inline-flex items-center space-x-1 ${sizeClasses[size]} bg-green-50 text-green-700 border border-green-200 rounded-full font-medium`}
      >
        <CheckCircle className={iconSizeClasses[size]} />
        <span>Qualified</span>
      </span>
    );
  }

  if (isQualified === false) {
    return (
      <span
        className={`inline-flex items-center space-x-1 ${sizeClasses[size]} bg-gray-50 text-gray-600 border border-gray-200 rounded-full font-medium`}
      >
        <XCircle className={iconSizeClasses[size]} />
        <span>No Qualified</span>
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center space-x-1 ${sizeClasses[size]} bg-amber-50 text-amber-700 border border-amber-200 rounded-full font-medium`}
    >
      <HelpCircle className={iconSizeClasses[size]} />
      <span>Sin calificar</span>
    </span>
  );
};

export default LeadQualifiedBadge;
